<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-4 mt-5">
                    <a href="#main" class="btn btn-sm border-dark" title="Voltar ao topo"><font-awesome-icon icon=arrow-up /></a>
                </div>    
                <div class="col-4 text-center p-2">
                    <b-img src='/static/img/ibiuna.png' fluid alt="Responsive image" width="80"></b-img>
                    <br><br>
                    <p>LLIÈGE © 2014 - {{ new Date().getFullYear() }}</p>
                    <p>Todos os direitos reservados.</p>
                </div>
            </div>    
        </div>
        
    </div>
</template>
<script>
export default {
  name: 'Rodape'
}
</script>
<style scoped>
p {
    color: #000;
}
a:hover {
    background-color: #9b6ee1;
    border: none;
    color: #fff;
}

</style>




// WEBPACK FOOTER //
// src/components/Rodape.vue